module.exports = require('./helpers/bundle-url').getBundleURL('aL8Pt') + "logo.7718c6df.svg";